import { render, staticRenderFns } from "./RecoverHash.vue?vue&type=template&id=28c9e6c3&scoped=true&lang=pug&"
import script from "./RecoverHash.vue?vue&type=script&lang=ts&"
export * from "./RecoverHash.vue?vue&type=script&lang=ts&"
import style0 from "./RecoverHash.vue?vue&type=style&index=0&id=28c9e6c3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c9e6c3",
  null
  
)

export default component.exports